import { subscriptionDiscountSchema } from "@/schemas/subscription-discount";

import { getAppUrl } from "@/helper/url";

import type { ApplyDiscount } from "@/types";

const url = `${getAppUrl()}/api/subscription-discount`;

export const fetchSubscriptionDiscount = async () => {
  try {
    const response = await fetch(url);

    if (!response.ok) {
      throw new Error("Falha ao buscar desconto da assinatura");
    }

    const data = await response.json();

    return subscriptionDiscountSchema.parse(data);
  } catch (error) {
    console.error("Erro ao processar desconto da assinatura:", error);
    throw new Error(
      error instanceof Error
        ? error.message
        : "Falha ao buscar desconto da assinatura"
    );
  }
};

export const postSubscriptionDiscount = async (data: ApplyDiscount) => {
  try {
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || "Falha ao aplicar desconto");
    }

    const responseData = await response.json();
    return responseData;
  } catch (error) {
    console.error("Erro ao aplicar desconto:", error);
    throw new Error(
      error instanceof Error ? error.message : "Falha ao aplicar desconto"
    );
  }
};
